import React from "react";
import MateriaisPopover from "../../../../detail/components/MateriaisPopover";
import AreaTipoDivergenciaEnum from "../../../AreaTipoDivergenciaEnum";
import FinalStepTemplate, {
  useBuildDefaultInfoComponent,
} from "../../../template/FinalStepTemplate";
import useBuildSubmitHandler from "../../../template/UseBuildSubmitHandler";
import { transforSelectItemToDivergenciaInfo } from "../../../template/utils";
import TipoDivergenciasKey from "../../../TipoDivergenciasKey";
import { TipoDivergenciaComponent } from "../../../TiposDeDivergencias";
import ProblemaDeQualidadeTecidoObservacaoStep from "./ProblemaDeQualidadeTecidoObservacaoStep";
import { AviamentoProps } from "./ProblemaDeQualidadeTecidoObservacaoStep";
import LabelValueWithSubtitle from "../../../components/LabelValueWithSubtitle";
import TipoDivergenciasInfoKey from "../../../TipoDivergenciasInfoKey.";

const ProblemaDeQualidadeTecidoFinalStep: TipoDivergenciaComponent<
  AviamentoProps
> = ({ onSetStep, onBack, payload }) => {
  const onBackHandler = () => {
    onBack({
      component:
        ProblemaDeQualidadeTecidoObservacaoStep as TipoDivergenciaComponent,
    });
  };
  const infoComponents = [
    ...useBuildDefaultInfoComponent(
      AreaTipoDivergenciaEnum.PLANEJAMENTO_DEMANDA,
      TipoDivergenciasKey.PROBLEMA_DE_QUALIDADE_TECIDO
    ),
    <MateriaisPopover
      materiais={payload.materiais.map(transforSelectItemToDivergenciaInfo)}
    ></MateriaisPopover>,
    <LabelValueWithSubtitle
      label="Descrição do problema"
      value={`${payload.problemDescription}`}
      subtitle={""}
    />,
  ];

  const key = TipoDivergenciasKey.PROBLEMA_DE_QUALIDADE_TECIDO;
  const { loadingSave, loadingTipoDivergencia, handleSubmit } =
    useBuildSubmitHandler(key, onSetStep);

  return (
    <FinalStepTemplate
      loading={loadingSave || loadingTipoDivergencia}
      onBack={onBackHandler}
      onSetStep={(step) => {
        handleSubmit(step, [
          ...payload.materiais.map((item) => {
            return {
              tipo: item.tipo,
              value: item.id.toString(),
              material: item.material
            };
          }),
          {
            tipo: TipoDivergenciasInfoKey.AJUSTE_MP,
            value: payload.problemDescription,
          },
        ]);
      }}
      progressValue={90}
      stepNumber={"4"}
      infoComponents={infoComponents}
    />
  );
};

export default ProblemaDeQualidadeTecidoFinalStep;
